import PropTypes from 'prop-types';
import React from 'react';
import { alignConstants, sizeConstants } from './dropdownConstants';
import classnames from 'classnames';
import styles from './Dropdown-style.scss';

const { ALIGN_LEFT, ALIGN_RIGHT, ALIGN_CENTER } = alignConstants;
const { SIZE_SMALL, SIZE_MEDIUM, SIZE_LARGE, SIZE_EXTRA_LARGE } = sizeConstants;

class Dropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isClient: false,
            isVisible: false,
        };

        this.dropdown = null;
        this.hide = this.hide.bind(this);
        this.show = this.show.bind(this);
        this.adjustLeftStyle = this.adjustLeftStyle.bind(this);
    }

    componentDidMount() {
        window.addEventListener('orientationchange', this.adjustLeftStyle);
        // Initialize alignments
        this.setState({ isClient: true }, () => {
            // eslint-disable-line react/no-did-mount-set-state
            this.adjustLeftStyle();
        });
    }

    componentDidUpdate(prevProps) {
        if(!prevProps.forceOpen && this.props.forceOpen) {
            this.show();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('orientationchange', this.adjustLeftStyle);
    }

    adjustLeftStyle() {
        const { align } = this.props;
        const { width } = this.dropdown.getBoundingClientRect();

        switch (align) {
            case ALIGN_RIGHT:
                this.dropdown.style.right = 0;
                // `right` alignments need no further checking / calculations, exit function
                return;

            case ALIGN_CENTER:
                this.dropdown.style.left = `calc(50% - ${width / 2}px)`;
                break;

            case ALIGN_LEFT:
                this.dropdown.style.left = 0;
                break;
        }

        const { left } = this.dropdown.getBoundingClientRect();
        const screenWidth = document.body.getBoundingClientRect().width;

        // Check if initial position overflows window boundaries and re-position if true
        if (left + width > screenWidth) {
            const overflow = left + width - screenWidth;
            // Subtract overflow from initial position
            this.dropdown.style.left =
                align === ALIGN_LEFT ? `${-overflow}px` : `calc(50% - ${width / 2 + overflow}px)`;
        }
    }

    show() {
        this.setState({ isVisible: true }, () => {
            const { onShow } = this.props;
            if (onShow) {
                onShow();
            }
        });
    }

    hide() {
        this.setState({ isVisible: false }, () => {
            const { onHide } = this.props;
            if (onHide) {
                onHide();
            }
        });
    }

    render() {
        const { children, className, size, hasDropdownHeader } = this.props;
        const { isClient, isVisible } = this.state;

        const wrapperClasses = classnames({
            [styles.wrapper]: true,
            [styles.isVisible]: isVisible,
            [className]: !!className,
        });
        const dropdownClasses = classnames({
            [styles.dropdown]: true,
            [styles.isVisible]: isVisible,
            [styles.hasDropdownHeader]: hasDropdownHeader,
        });
        const bodyWrapperClasses = classnames({
            [styles.bodyWrapper]: true,
            [styles.isVisible]: isVisible,
            [styles[size]]: !!size,
        });

        if (!children) {
            return null;
        }

        const trigger = children[0];
        const body = children.length > 1 ? children.slice(1) : null;

        return (
            <div className={wrapperClasses} onMouseEnter={this.show} onMouseLeave={this.hide}>
                {trigger}
                {isClient ? (
                    <div className={dropdownClasses}>
                        <div
                            className={bodyWrapperClasses}
                            ref={element => {
                                this.dropdown = element;
                            }}
                        >
                            {body}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

Dropdown.defaultProps = {
    align: ALIGN_LEFT,
    size: SIZE_MEDIUM,
    hasDropdownHeader: false,
    forceOpen: false,
};

Dropdown.propTypes = {
    align: PropTypes.oneOf([ALIGN_LEFT, ALIGN_RIGHT, ALIGN_CENTER]),
    size: PropTypes.oneOf([SIZE_SMALL, SIZE_MEDIUM, SIZE_LARGE, SIZE_EXTRA_LARGE]),
    children: PropTypes.array,
    className: PropTypes.string,
    onHide: PropTypes.func,
    onShow: PropTypes.func,
    hasDropdownHeader: PropTypes.bool,
    forceOpen: PropTypes.bool,
};

export { alignConstants, sizeConstants };
export default Dropdown;
